import type { FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';

export enum OPTIONS_SORT {
  /** NUM if counters exist, ALPHABET if text labels exist, otherwise NONE */
  AUTO = 'AUTO',
  /** Keep the original static order as-is */
  NONE = 'NONE',
  /** Always sort alphabetically by label */
  ALPHABET = 'ALPHABET',
  /** Always sort descending by counter (alphabetic tiebreaker) */
  NUM = 'NUM',
  /** NUM if counters exist, otherwise keep the original static order */
  NUM_OR_NONE = 'NUM_OR_NONE',
}

const hasCounters = (options: FilterDataOption[]): boolean => options.some((o) => o.counter !== undefined);
const hasTextLabels = (options: FilterDataOption[]): boolean => options.some((o) => o.label.trim() !== '');

const sortOptionsByNum = (options: FilterDataOption[]): FilterDataOption[] =>
  options.sort((a, b) => (b.counter ?? 0) - (a.counter ?? 0));

const sortOptionsByAlphabetic = (options: FilterDataOption[]): FilterDataOption[] =>
  options.sort((a, b) => a.label.localeCompare(b.label));

export const resolveSort = (optionsSort: OPTIONS_SORT, options: FilterDataOption[]): OPTIONS_SORT => {
  if (optionsSort === OPTIONS_SORT.AUTO) {
    if (hasCounters(options)) return OPTIONS_SORT.NUM;
    if (hasTextLabels(options)) return OPTIONS_SORT.ALPHABET;
    return OPTIONS_SORT.NONE;
  }

  if (optionsSort === OPTIONS_SORT.NUM_OR_NONE) {
    return hasCounters(options) ? OPTIONS_SORT.NUM : OPTIONS_SORT.NONE;
  }

  return optionsSort;
};

export const sortOptions = (optionsSort: OPTIONS_SORT, options: FilterDataOption[]): FilterDataOption[] => {
  if (optionsSort === OPTIONS_SORT.NONE) return options;
  const resolved = resolveSort(optionsSort, options);
  if (resolved === OPTIONS_SORT.NUM) return sortOptionsByNum(sortOptionsByAlphabetic(options));
  if (resolved === OPTIONS_SORT.ALPHABET) return sortOptionsByAlphabetic(options);
  return options;
};
